// Components
import {
  Section,
  Box,
  Select,
  SectionSkeleton,
} from '@zolteam/zol-admin-ui';

/**
 * ContentTranslationStatus component.
 * @param {object} props
 * @param {Array<{label:string, value:string}>} props.statusListOptions
 * @param {Function} props.onStatusChange
 * @param {ContentTranslationStatus} props.editedStatus
 * @param {string} props.sectionTitle
 * @param {string} props.statusTitle
 * @param {string} props.selectStatusPlaceholder
 * @param {boolean} [props.isLoading=false]
 * @param {JSX.Element | null} [props.statusTag=null]
 * @returns {JSX.Element}
 */
function ContentTranslationStatus({
  statusListOptions,
  onStatusChange,
  editedStatus,
  sectionTitle,
  statusTitle,
  selectStatusPlaceholder,
  isLoading = false,
  statusTag = null,
}) {
  return isLoading
    ? <SectionSkeleton />
    : (
      <Section id="status-section" title={sectionTitle}>
        <Box
          direction="row"
          justify="space-between"
          align="center"
        >
          <span className="p2-default">{statusTitle}</span>
          {statusTag}
        </Box>
        <Select
          id="status"
          name="status"
          placeholder={selectStatusPlaceholder}
          value={editedStatus}
          options={statusListOptions}
          onChange={onStatusChange}
        />
      </Section>
    );
}

export default ContentTranslationStatus;
